/**
 * This file specifies the state of the application in response to App actions
 */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  loading: false,
  error: null,
};

const slice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    getUser: (state) => ({ ...state, loading: true }),
    getUserError: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload.error,
    }),
    getUserSuccess: (state, action) => ({
      ...state,
      user: action.payload.user,
      loading: false,
      error: null,
    }),
    updateUserSuccess: (state, action) => ({
      user: action.payload.user,
      loading: false,
      error: null,
    }),
    updateUserRequestItemLeadTimesCount: (state, action) => ({
      ...state,
      user:
        state.user && state.user.vendor
          ? {
              ...state.user,
              vendor: {
                ...state.user.vendor,
                requested_item_lead_times_count: action.payload.count,
              },
            }
          : state.user,
    }),
  },
});

export const { reducer, actions } = slice;

export default reducer;
